<div class="ctr">
  <div class="red">
    <div [innerHTML]="pageBottomComponent?.statContent" ></div>
  </div>
</div>
<div class="ctr">
  <div [innerHTML]="pageTopComponentMobile?.statContent">
  </div>
</div>
